import { Injector } from '@angular/core';
import { functionCtaType } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/cta-button-actions.utils';
import { submitBusinessOnboarding } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/onboarding-zone/business-onboarding-actions.utils';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';

export const businessOnboardingActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.BUSINESS_ONBOARDING_SUBMIT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      submitBusinessOnboarding(injector, attri.widgetProperties);
    },
  ],
]);
